<template>
  <section
    :class="`font--base tw-transition-all tw-duration-200 tw-ease-in-out internal-chat ${open ? 'internal-chat--open' : 'internal-chat--close'}`"
  >
    <header class="tw-relative">
      <button :class="`tw-w-full tw-bg-ublue-500 tw-px-3 tw-py-2 tw-flex tw-items-center tw-rounded-tl-lg tw-rounded-tr-lg tw-text-white ${open ? '' : 'tw-rounded-b-lg'}`" @click="open = !open">
        <button class="tw-p-2" v-if="selectedProfessional || settingsOpen" @click="handleBackListing">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.8333 9.99999H4.16666M4.16666 9.99999L9.99999 15.8333M4.16666 9.99999L9.99999 4.16666" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="tw-text-sm tw-font-medium tw-leading-5 tw-truncate">
          {{ title }}
          <unread-message-badge v-if="totalUnreadMessage > 0 && !this.selectedProfessional" :counter="totalUnreadMessage" />
        </div>
        <div class="tw-ml-auto tw-flex tw-items-center tw-pl-2">
          <button @click="openSettingsPage" v-if="!this.selectedProfessional && open" class="tw-mr-2 tw-p-2">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.5 6.66667L12.5 6.66667M12.5 6.66667C12.5 8.04738 13.6193 9.16667 15 9.16667C16.3807 9.16667 17.5 8.04738 17.5 6.66667C17.5 5.28596 16.3807 4.16667 15 4.16667C13.6193 4.16667 12.5 5.28596 12.5 6.66667ZM7.5 13.3333L17.5 13.3333M7.5 13.3333C7.5 14.714 6.38071 15.8333 5 15.8333C3.61929 15.8333 2.5 14.714 2.5 13.3333C2.5 11.9526 3.61929 10.8333 5 10.8333C6.38071 10.8333 7.5 11.9526 7.5 13.3333Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <span :class="`tw-p-2 tw-transition ${open ? 'tw-rotate-0' : 'tw-rotate-180'}`">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 7.5L10 12.5L15 7.5" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </div>
      </button>
    </header>
    <div v-if="open && necessaryPlanMessage && !selectedProfessional" class="tw-px-3 tw-py-2 tw-bg-blackfriday tw-text-white" v-html="necessaryPlanMessage">
    </div>
    <div v-if="open && !loading && loaded && !selectedProfessional && !settingsOpen" class="tw-p-2.5 tw-overflow-auto scrollbar-thin">
      <ul>
        <li v-for="professional in sortedProfessionals" :key="professional.id" >
          <button @click="selectedProfessional = professional" class="tw-flex tw-justify-between tw-items-center tw-px-2 tw-py-2.5 tw-rounded-md hover:tw-bg-ublue-50 tw-w-full">
            <div class="tw-text-left tw-min-w-0">
              <div class="tw-text-sm tw-text-ugray-700 tw-font-medium tw-leading-5 tw-truncate">
                {{ professional.full_name }}
              </div>
              <div v-if="professional.messages_count == 0" class="tw-italic tw-text-xs tw-text-ugray-400 tw-leading-4.5">
                Não há mensagens trocadas
              </div>
              <div v-if="professional.last_message" class="tw-text-xs tw-text-ugray-700 tw-leading-4.5 tw-truncate">
                {{professional.last_message}}
              </div>
            </div>

            <unread-message-badge  v-if="professional.unread_messages_count > 0" :counter="professional.unread_messages_count" />
          </button>
        </li>
      </ul>
    </div>
    <div v-if="open && loading && !loaded" class="tw-flex-1 tw-flex tw-items-center">
      <img :src="loadingAsset" class="tw-mx-auto">
    </div>
    <conversation
      :selectedProfessional="selectedProfessional"
      @messages="handleMessagesForProfessional"
      @append-message="appendMessage"
      v-if="selectedProfessional && open"
      :current-professional="currentProfessional"
      @mark-as-read="markAsRead"
      :loading-asset="loadingAsset"
      :no-messages-asset="noMessagesAsset"
    />
    <settings
      v-if="settingsOpen && open"
      :enable-notification-sound="enableNotificationSound"
      @enable-notification-sound="enableNotificationSound = !enableNotificationSound"
      :can-manage-establishment="canManageEstablishment"
      />
  </section>
</template>

<script>
import axios from "axios";
import Conversation from "./conversation.vue";
import UnreadMessageBadge from "./unread-message-badge.vue";
import Settings from "./settings.vue";

axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "X-CSRF-Token": document
    .querySelector("meta[name=csrf-token]")
    .getAttribute("content"),
};

export default {
  props: [
    "currentProfessional",
    "newMessageSound",
    "loadingAsset",
    "noMessagesAsset",
    "faviconNotification",
    "faviconEmpty",
    "necessaryPlanMessage",
    "canManageEstablishment"
  ],
  components: {
    Conversation,
    UnreadMessageBadge,
    Settings
  },
  data() {
    const isChatOpen = localStorage.getItem("internalChat:open")
    return {
      professionals: [],
      loading: false,
      open: isChatOpen ? JSON.parse(isChatOpen) : false,
      loaded: false,
      selectedProfessional: null,
      timeoutGetProfessionals: null,
      enableNotificationSound: true,
      settingsOpen: false,
    };
  },
  mounted(){
    this.$refs.faviconElement = document.getElementById("favicon");
    document.addEventListener("chat:new-event", this.messageStreamEvents)

    this.timeoutGetProfessionals = setTimeout(() => {
      this.getProfessionals();
    }, 1000);

    const enableNotificationSound = localStorage.getItem("internalChat:enableNotificationSound")
    if (enableNotificationSound !== null) {
      this.enableNotificationSound = JSON.parse(enableNotificationSound)
    }

    window.addEventListener('storage', this.localStorageListener);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleResize);
    document.removeEventListener('chat:new-event', this.messageStreamEvents);
    clearTimeout(this.timeoutGetProfessionals)
  },
  methods: {
    async getProfessionals() {
      clearTimeout(this.timeoutGetProfessionals)
      this.loading = true;
      try {
        const response = await axios.get("/chat/conversations");
        this.professionals = response.data.data.professionals.map(
          (professional) => ({
            ...professional,
            messages: [],
            updatedAt: new Date(professional.updated_at),
            loadedMessages: !professional.chat_conversation_id,
          })
        );
        this.loadSelectedProfessional()
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.loaded = true;
      }
    },
    handleMessagesForProfessional(professional) {
      this.professionals = this.professionals.map((p) => {
        if (p.id === professional.id) {
          return professional;
        }
        return p;
      });
      this.selectedProfessional = professional
    },
    handleReceiveNewMessage(message){
      let newProfessional = null;
      this.professionals = this.professionals.map((professional) => {
        if (professional.local_chat_conversation_id != message.local_chat_conversation_id) {
          return professional;
        }

        newProfessional = {
          ...professional,
          updated_at: message.created_at,
          updatedAt: new Date(message.created_at),
          last_message: message.content,
          chat_conversation_id: professional.chat_conversation_id ? professional.chat_conversation_id : message.chat_conversation_id,
          messages_count: professional.messages_count + 1,
          messages: this.updateMessage(professional.messages, message),
        }
        return newProfessional;
      });

      if (this.selectedProfessional && this.selectedProfessional.local_chat_conversation_id === newProfessional.local_chat_conversation_id) {
        this.selectedProfessional = newProfessional
      }
    },
    playNewMessageSound(){
      if (!this.enableNotificationSound) return
      let notificationSound = new Audio(this.newMessageSound);
      notificationSound.play();
    },
    updateProfessional(selectedProfessional, data){
      this.professionals = this.professionals.map((professional) => {
        if (selectedProfessional.id === professional.id) {
          return {
            ...professional,
            ...data
          };
        }

        if (this.selectedProfessional && this.selectedProfessional.id === selectedProfessional.professional_id) {
          this.selectedProfessional = {
            ...this.selectedProfessional,
            ...data
          }
        }

        return professional;
      });
    },
    async markAsRead(professional){
      try {
        const response = await axios.post(`/chat/conversations/${professional.chat_conversation_id}/mark_all_read`);
        this.updateProfessional(professional, {unread_messages_count: 0})
      } catch (error) {
        console.error(error);
        Bugsnag.notify(error)
      }
    },
    handleBackListing(event){
      event.preventDefault();
      event.stopPropagation();
      this.selectedProfessional = null;
      this.settingsOpen = false
    },
    appendMessage(professional, message){
      const newProfessional = {
        ...professional,
        ...this.selectedProfessional,
        updated_at: message.created_at,
        updatedAt: new Date(message.created_at),
        last_message: message.content,
        messages: this.updateMessage(this.selectedProfessional.messages, message),
      }

      if (this.selectedProfessional.id == professional.id) {
        this.selectedProfessional = newProfessional
      }

      this.professionals = this.professionals.map((professionalItem) => {
        if (professionalItem.id === newProfessional.id) {
          return newProfessional;
        }
        return professionalItem;
      });
    },
    updateMessage(messages, newMessage){
      let messageExists = false;
      const newMessages = messages.map((message) => {
        if ((newMessage.local_id && message.local_id === newMessage.local_id) || (newMessage.id && message.id === newMessage.id)) {
          messageExists = true;
          return newMessage;
        }
        return message;
      });

      if (messageExists) {
        return [...newMessages]
      }

      return [
        ...messages,
        newMessage,
      ]
    },
    handleUnreadMessagesCountEvent(data){
      let newProfessional = null;
      this.professionals = this.professionals.map((professional) => {
        if (professional.local_chat_conversation_id != data.local_chat_conversation_id) {
          return professional;
        }

        newProfessional = {
          ...professional,
          unread_messages_count: data.unread_messages_count,
          messages_count: data.messages_count,
        }

        return newProfessional;
      });

      if (this.selectedProfessional && this.selectedProfessional.local_chat_conversation_id === newProfessional.local_chat_conversation_id) {
        this.selectedProfessional = newProfessional
      }
    },
    openSettingsPage(event){
      event.stopPropagation()
      event.preventDefault()
      this.selectedProfessional = null
      this.settingsOpen = !this.settingsOpen
      this.open = true
    },
    localStorageListener(event){
      if (event.key === "internalChat:enableNotificationSound") {
        this.enableNotificationSound = JSON.parse(event.newValue)
      }
    },
    messageStreamEvents(event){
      if (event.detail.action == "new_message") {
        this.handleReceiveNewMessage(event.detail.data)
        if (
          this.currentProfessional.id != event.detail.data.professional_id
          && (document.visibilityState === 'hidden' || event.detail.data.professional_id != this.selectedProfessional?.id)
        ) {
          this.playNewMessageSound()
        }
      }

      if (event.detail.action == "update_status_message") {
        this.handleReceiveNewMessage(event.detail.data)
      }

      if (event.detail.action == "unread_messages_count") {
        this.handleUnreadMessagesCountEvent(event.detail.data)
      }
    },
    countUnreadMessagesProfessional(professional){
      if (!professional.messages || professional.messages.length == 0) {
        return professional.unread_messages_count
      }

      return professional.messages.reduce((acc, message) => {
        if (message.professional_id == this.currentProfessional.id || message.status == "read") {
          return acc
        }
        return acc + 1
      }, 0);
    },
    loadSelectedProfessional(){
      const selectedProfessionalId = localStorage.getItem("internalChat:selectedProfessionalId")
      if (selectedProfessionalId) {
        this.selectedProfessional = this.professionals.find(professional => professional.id == JSON.parse(selectedProfessionalId))
      }
    }
  },
  computed: {
    totalUnreadMessage(){
      if(this.sortedProfessionals.length == 0) {
        return 0
      }
      return this.sortedProfessionals.reduce((acc, professional) => {
        return acc + professional.unread_messages_count
      }, 0)
    },
    title(){
      if (this.settingsOpen) {
        return "Configurações"
      }

      if (this.selectedProfessional) {
        return this.selectedProfessional.full_name
      }
      return "Chat da clínica"
    },
    sortedProfessionals(){
      return this.professionals.sort(
        (objA, objB) => Number(objB.updatedAt) - Number(objA.updatedAt),
      ).map(professional => {
        return {
          ...professional,
          last_message: professional.last_message.split("<br>").join(" "),
          unread_messages_count: this.countUnreadMessagesProfessional(professional),
        }
      });
    }
  },
  watch: {
    open(open) {
      localStorage.setItem("internalChat:open", JSON.stringify(open))
      if (open && !this.loaded) {
        this.getProfessionals();
      }
      if (!open) {
        this.selectedProfessional = null
        this.settingsOpen = false
      }
    },
    totalUnreadMessage(totalUnreadMessage){
      this.$refs.faviconElement.setAttribute(
        "href",
        totalUnreadMessage > 0 ? this.faviconNotification : this.faviconEmpty
      )
    },
    enableNotificationSound(enableNotificationSound){
      localStorage.setItem("internalChat:enableNotificationSound", JSON.stringify(enableNotificationSound))
    },
    selectedProfessional(selectedProfessional){
      localStorage.setItem("internalChat:selectedProfessionalId", selectedProfessional == null ? "" : selectedProfessional.id)
    }
  },
};
</script>
